<div   class="" >
  
    <div id="styleSelector"  class="style-block staff-container  open {{slide?'animate-block':'slide-out'}}">
    <div class="container h-100">
        <div class="row align-items-center">
          <div class="{{isView?'col-12':'col-10'}} mx-auto user-form ">
              <div class='row add-edit-header'>  
                  <div class="ui-g-10">
                     
                      <h4>Edit Net Weight</h4>
                  </div> 
                  <div class="ui-g-2" (click)="closeEvent($event)" pTooltip="Click to close a Job Edit" tooltipPosition="top">
                      <i class="fa fa-window-close fa-2x "></i>
                   </div>    
             </div> 
                       <div class="">                    
            <form [formGroup]="jobForm" >
              <div class='row form-group'>
                <div class='ui-g-12  mt-3'>
                        <label for="netweight">Net Weight (Tonnes)</label>
                  <input class='ui-g-12' id="netweight" type="number" class="form-control"size="30" formControlName='netweight' pInputText>
                </div>
              </div>   
            
              <div class='row button-cls'>
                <div class='ui-g-12'>
                  <p-button label="Update" (onClick)="updateJob($event)"></p-button> 
                </div>
              </div>
            
            </form>
        
            </div>
          </div>
          </div>
        </div>
      </div>
      </div>